import { serviceName } from '../resources/serviceConstants';
import {
  ROLES_LIST,
  ENABLE_OR_DISABLE_ROLE,
  ADD_EDIT_ROLES,
} from '../resources/endPoint';

export const roleList = () => {
  // API call to fetch role list
  return {
    url: ROLES_LIST,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ROLES_MS,
  };
};

export const enableOrDisableRole = (data) => {
  // API call to enable/disable role
  return {
    url: ENABLE_OR_DISABLE_ROLE,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.ROLES_MS,
  };
};

export const addRolesData = (roleName, roleDescription) => {
  const data = {
    role_name: roleName,
    description: roleDescription,
  };

  return {
    url: ADD_EDIT_ROLES,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.ROLES_MS,
  };
};

export const editRolesData = (roleId, roleName, roleDescription) => {
  const data = {
    role_id: roleId,
    role_name: roleName,
    description: roleDescription,
  };

  return {
    url: ADD_EDIT_ROLES,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.ROLES_MS,
  };
};
